import { Component, Input, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerSubscriptionFrequency } from "src/app/shared/models/enums/customer-subscription-frequency.enum";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-canvas-subscription-items-list",
	templateUrl: "./canvas-subscription-items-list.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class CanvasSubscriptionItemsListComponent implements OnInit {
	@Input() canvasIndex;

	subscriptionItemSelected: OOCanvasMenuItem;
	subscriptionItemSelectedAvailableFrequencies: { label: string; value: number; disabled: boolean }[] = [];

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.frequencyDisplayNameSet();
	}

	frequencyDisplayNameSet() {
		this.venueService.ooCanvases[this.canvasIndex].menuItems.forEach((cmi) => {
			if (cmi.subscriptionAllowedFrequencies?.length > 0) {
				cmi.subscriptionAllowedFrequencies.forEach((freq) => {
					if (!cmi.subscriptionFrequencyDisplayName) {
						cmi.subscriptionFrequencyDisplayName = [];
					}
					if (!cmi.subscriptionFrequencyDisplayName.some((i) => i === this.app.references.toTitleCase(CustomerSubscriptionFrequency[freq]))) {
						cmi.subscriptionFrequencyDisplayName.push(this.app.references.toTitleCase(CustomerSubscriptionFrequency[freq]));
					}
				});
			}
		});
	}

	onAddItem() {
		this.subscriptionItemSelected = new OOCanvasMenuItem({
			canvasKey: this.venueService.ooCanvases[this.canvasIndex].canvasKey,
			unsaved: true,
		});
	}

	onItemDelete() {
		this.venueService.canvasMenuItemRemove(this.subscriptionItemSelected.menuItemKey, this.subscriptionItemSelected.canvasKey);
	}

	onItemSave() {
		this.venueService.canvasMenuItemSave(this.subscriptionItemSelected);
	}

	onSelectItem(rec: OOCanvasMenuItem) {
		this.subscriptionItemSelected = rec;
		this.setFrequencies();
	}

	onSetSelectedMenuItem() {
		this.subscriptionItemSelected.ooMenuItem = this.venueService.ooMenuItems.find((itm) => itm.menuItemKey === this.subscriptionItemSelected.menuItemKey);
		this.setFrequencies();
	}

	setFrequencies() {
		this.subscriptionItemSelectedAvailableFrequencies = this.venueService.subscriptionFrequencyOptions();
		this.subscriptionItemSelectedAvailableFrequencies.forEach((freq) => {
			if (!this.subscriptionItemSelected.ooMenuItem.subscriptionAllowedFrequencies.some((i) => i === freq.value)) {
				freq.disabled = true;
			}
		});
	}
}
